import { useEffect } from 'react';

import { useDispatch } from 'src/store/react';
import { updateKeywordsField } from 'src/store/search';

export const useSQCKeywordFieldUpdate = ({
  isQueryModified = false,
  searchExecutedKeywords,
}: {
  isQueryModified?: boolean;
  searchExecutedKeywords?: string;
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (isQueryModified && searchExecutedKeywords) {
      dispatch(updateKeywordsField(searchExecutedKeywords));

      const keywordId = document.getElementById('keywords-input');
      if (keywordId) {
        keywordId.blur();
      }
    }
  }, [isQueryModified, searchExecutedKeywords, dispatch]);
};
